<template>
  <div>
    <main class="container">
      <table-header
        title="Список ролей"
        :is-loading="isLoading"
        :is-empty="!roles.length"
      />
      <div class="table-wrapper">
        <div class="table-container">
          <transition
            name="fade"
            mode="out-in"
          >
            <table
              v-if="!isLoading && roles.length"
              class="table interactive"
            >
              <thead>
                <tr>
                  <th>
                    <div class="table__header_setings">
                      <i class="material-icons">tune</i>
                    </div>
                  </th>
                  <th
                    v-for="header in tableHeaders"
                    :key="header"
                  >
                    <div class="table__header">
                      {{ header }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="it in roles"
                  :key="it.id"
                >
                  <td>
                    <role-list-actions
                      :role="it"
                      @editRole="openEditRoleModal"
                    />
                  </td>
                  <td>{{ it.name }}</td>
                  <td>{{ it.availableFor.join(', ') }}</td>
                  <td>{{ it.compatibleWith.join(', ') }}</td>
                </tr>
              </tbody>
            </table>
          </transition>
        </div>
      </div>
    </main>
    <edit-role-modal
      v-if="user"
      v-model="isEditRoleModalShown"
      :role-edited="roleEdited"
      :role-list="roles"
      @editRole="editRole"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TableHeader from '@/components/table/TableHeader';
import EditRoleModal from '@/components/role-list/EditRole';
import RoleListActions from '@/components/role-list/RoleListActions';

export default {
  name: 'RoleList',
  components: {
    TableHeader,
    EditRoleModal,
    RoleListActions,
  },
  data: () => ({
    isLoading: true,
    roles: [],
    tableHeaders: ['Роль', 'Доступность', 'Совместимость'],
    isEditRoleModalShown: false,
    roleEdited: {},
  }),
  computed: {
    ...mapState(['user', 'isBackgroundBlurred']),
  },
  created() {
    this.getRoles();
  },
  methods: {
    async getRoles() {
      this.isLoading = true;
      const { items } = await this.$http.get('users/1.0/roles', {
        params: {
          limit: this.limit,
          skip: this.offset,
          ...this.filters,
        },
      });

      this.isLoading = false;

      this.roles = items;
    },
    openEditRoleModal(role) {
      this.isEditRoleModalShown = true;
      this.roleEdited = role;
    },
    async editRole() {
      await this.getRoles();
      this.isEditRoleModalShown = false;
    },
  },
};
</script>
